import { createStyles, makeStyles } from '@material-ui/core';
import React from 'react';
import { Button } from './Button';
import { Typography } from './Typography';

export interface InputSubmitProps {
  value?: string;
  inputPlaceholder?: string;
  inputDisabled?: boolean;
  buttonText?: JSX.Element | string;
  buttonDisabled?: boolean;
  onClick?: () => void;
  readOnly?: boolean;
  onChange?: (value: string) => void;
}

export const useInputSubmitStyle = makeStyles(() =>
  createStyles({
    container: {
      display: 'flex',
      marginBottom: '8px',
    },
    input: {
      flexGrow: 1,
      padding: '11px 8px',
      border: '1px solid #b6b6b6',
      fontSize: '1.8rem',
    },
    button: {
      boxShadow: 'none',
    },
  }),
);

export const InputSubmit = React.forwardRef<HTMLInputElement, InputSubmitProps>(
  (
    {
      value = '',
      inputPlaceholder,
      inputDisabled = false,
      buttonText,
      buttonDisabled,
      onClick,
      readOnly,
      onChange,
    },
    ref,
  ) => {
    const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange && onChange(e.target.value);
    };
    const styles = useInputSubmitStyle();
    return (
      <div className={styles.container}>
        <input
          className={styles.input}
          ref={ref}
          type='text'
          value={value}
          placeholder={inputPlaceholder}
          disabled={inputDisabled}
          onChange={handleOnChange}
          readOnly={readOnly}
        />
        <div className={styles.button}>
          <Button type='button' onClick={onClick} disabled={buttonDisabled}>
            <Typography>{buttonText}</Typography>
          </Button>
        </div>
      </div>
    );
  },
);

InputSubmit.displayName = 'InputSubmit';
